import React from 'react'
import { useTranslation } from 'react-i18next';

const Pricing = () => {
    const { t } = useTranslation();
    
  return (
    <div className='container flex flex-col items-center gap-8 mb-12'>
        <div className='flex flex-col items-center gap-2'>
            <h2 className='pt-10 mb-5 text-2xl font-bold text-center md:text-3xl'>{t('pricing.Wat kost Peppol')}</h2>
            <p className='text-center'>{t('pricing.Met onze Peppol-oplossing zit je goed')}</p>
        </div>

        <div className='grid gap-4 md:gap-8 md:grid-cols-3'>
            <div className='p-4 border border-t-2 border-t-legoOrange'>
                <p className='font-medium text-center'>{t('pricing.25 EUR per maand')}</p>
            </div>
            <div className='p-4 border border-t-2 border-t-legoOrange'>
                <p className='font-medium text-center'>{t('pricing.Eerste 6 maanden gratis')}</p>
            </div>
            <div className='p-4 border border-t-2 border-t-legoOrange'>
                <p className='font-medium text-center'>{t('pricing.Opstartkosten')}</p>
            </div>
        </div>

        <div className='flex flex-col items-center gap-2'>
            <p className='font-bold text-center'>{t('pricing.Iets meer informatie nodig')}</p>
            <p className='text-center'>{t('pricing.Onze mensen staan voor jou klaar')}</p>
            <a className='px-3 py-2 font-medium text-white bg-legoOrange min-h-10' href="https://outlook.office.com/bookwithme/user/455ff4396980438a8540b0001256a510%404e3ed852-201e-495a-a74c-7d4963db4dd6/meetingtype/c845902f-b4c8-48c9-b83c-d4fda5cfae40?anonymous">
                {t('pricing.Boek een afspraak')}
            </a>
        </div>
    </div>
  )
}

export default Pricing